import { Swiper } from '../lib/swiper';

const swiperDefaults = {
	normal: {
		speed: 1200,
		delay: 3000,
	},
	marquee: {
		speed: 4000,
		delay: 1,
	},
};

export function initAllSwipers() {
	const swipers = [];

	if (document.body.classList.contains('page-template-tmpl_home')) {
		const news = initNewsSwiper();
		const clients = initClientsSwiper();

		if (news) swipers.push(news);
		if (clients?.length) swipers.push(...clients);
	}

	// Observer for auto playing the swipers only if there in viewport
	swipers.forEach((swiper) => {
		const observer = new IntersectionObserver((entries, observer) => {
			entries.forEach((entry) => {
				if (entry.isIntersecting) {
					swiper.autoplay.start();
					observer.unobserve(swiper.el);
				}
			});
		});

		observer.observe(swiper.el);
	});
}

// Homepage News Swiper
function initNewsSwiper() {
	const sliderEl = document.querySelector('.news-swiper');
	if (!sliderEl) return null;
	const newsSwiper = new Swiper(sliderEl, {
		loop: false,
		grabCursor: false,
		slidesPerView: 4,
		spaceBetween: 24,
		centeredSlides: false,
		allowTouchMove: true,
		speed: swiperDefaults.normal.speed,
		autoplay: {
			delay: swiperDefaults.normal.delay,
		},
		breakpoints: {
			0: {
				slidesPerView: 1,
				spaceBetween: 15,
			},
			511: {
				slidesPerView: 2,
				spaceBetween: 15,
			},
			861: {
				slidesPerView: 3,
				spaceBetween: 20,
			},
			1126: {
				slidesPerView: 4,
				spaceBetween: 24,
			},
		},
		on: {
			init: function (swiper) {
				swiper.autoplay.stop();
			},
		},
	});
	return newsSwiper;
}

// Homepage Client Marquee 2 Swipers
function initClientsSwiper() {
	const sliders = document.querySelectorAll('.clients-swiper');

	if (sliders.length === 0) return [];

	const instances = [];

	sliders.forEach((sliderEl) => {
		if (sliderEl.swiper) {
			instances.push(sliderEl.swiper);
			return;
		}
		const reverse = sliderEl.dataset.reverseDirection === 'true';

		const clientsSwiper = new Swiper(sliderEl, {
			loop: true,
			grabCursor: false,
			slidesPerView: 'auto',
			spaceBetween: 24,
			centeredSlides: false,
			allowTouchMove: false,
			speed: swiperDefaults.marquee.speed,
			autoplay: {
				delay: swiperDefaults.marquee.delay,
				disableOnInteraction: false,
				reverseDirection: reverse,
			},
			on: {
				init: function (swiper) {
					swiper.autoplay.stop();
				},
			},
			breakpoints: {
				0: {
					spaceBetween: 10,
				},
				511: {
					spaceBetween: 15,
				},
			},
		});
		instances.push(clientsSwiper);
	});
	return instances;
}
